import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { AthleteSubscription } from '../../app.types';

type ReturnType = Promise<AxiosResponse<Array<AthleteSubscription>>>;

const getAthleteSubscriptions = (): ReturnType => Request.get(`/athlete-users/subscriptions`);

export default getAthleteSubscriptions;
